import { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

type UseDelayedNavigationProps = {
	path: string;
	delay?: number;
	shouldNavigate?: boolean;
};

function useDelayedNavigation({
	path,
	delay = 2000,
	shouldNavigate = true,
}: UseDelayedNavigationProps): void {
	const navigate = useNavigate();

	const navigateWithDelay = useCallback(() => {
		const timeoutId = setTimeout(() => {
			navigate(path);
		}, delay);

		return () => clearTimeout(timeoutId);
	}, [navigate, path, delay]);

	useEffect(() => {
		if (shouldNavigate) {
			return navigateWithDelay();
		}
		return () => {};
	}, [shouldNavigate, navigateWithDelay]);
}

export default useDelayedNavigation;
